import { object } from 'yup';

import {
    getCommonFieldsValidationSchema,
    getExtraFieldsValidationSchema,
} from './validateCommonFields';

export default (values) => {
    const shape = {
        ...getCommonFieldsValidationSchema(values),
        ...getExtraFieldsValidationSchema(values),
    };

    return object().shape(shape);
};
